export function isIframe() {
  return window.location !== window.parent.location
}

export function trackEvent(event_name, event_props) {
  window.amplitude && window.amplitude.track(event_name, event_props || {});
}

export function formatDateDisplay(date) {
  if (!date) {
    return ''
  }
  const created = new Date(date)
  const year = created.getFullYear()
  const month = String(created.getMonth() + 1).padStart(2, '0')
  const day = String(created.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function getLastNDays(n_days_from, n_days_to) {
  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - n_days_from);
  if (n_days_to) {
    endDate.setDate(endDate.getDate() - n_days_to);
  }

  // Format dates to 'YYYY-MM-DD'
  const formattedEndDate = endDate.toISOString().split('T')[0];
  const formattedStartDate = startDate.toISOString().split('T')[0];
  return [formattedStartDate, formattedEndDate];
}

export function isCollectAnalytics(product) {
  return product !== 'easydoc' && product !== 'macroexport' && product !== 'answersearch'
}

export const APPS_PRODUCT_MAP = {
  'Merge Duplicate Tickets': 'mergedup',
  'Auto Remove Attachments': 'redact',
  'Triggers+GPT': 'triggers_gpt',
  'Triggers+ChatGPT': 'triggers_gpt',
  'Ticket Classification': 'classify',
  'Automatic classify ticket by topic or intent': 'classify',
  'Ticket Parser Autofill': 'lookup',
  'Agent Co-writer': 'cowriter',
}
